var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterthan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_382_16036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.709839,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_382_16036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25065 15.1265C7.09787 14.9737 7.02148 14.7793 7.02148 14.5432C7.02148 14.3071 7.09787 14.1126 7.25065 13.9598L10.5007 10.7098L7.25065 7.45983C7.09787 7.30705 7.02148 7.11261 7.02148 6.8765C7.02148 6.64038 7.09787 6.44594 7.25065 6.29316C7.40343 6.14038 7.59787 6.064 7.83398 6.064C8.07009 6.064 8.26454 6.14038 8.41732 6.29316L12.2507 10.1265C12.334 10.2098 12.3932 10.3001 12.4282 10.3973C12.4626 10.4946 12.4798 10.5987 12.4798 10.7098C12.4798 10.8209 12.4626 10.9251 12.4282 11.0223C12.3932 11.1196 12.334 11.2098 12.2507 11.2932L8.41732 15.1265C8.26454 15.2793 8.07009 15.3557 7.83398 15.3557C7.59787 15.3557 7.40343 15.2793 7.25065 15.1265Z",
    fill: "#106F60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterthan);
export default __webpack_public_path__ + "static/media/greaterthan.f8d4ed19bd16a1bcf762818dbb69e02c.svg";
export { ForwardRef as ReactComponent };